import React from 'react';

const getHtmlString = (value) => {
	if (Array.isArray(value)) {
		return value.join('');
	}
	if (typeof value === 'string') {
		return value;
	}
	return '';
};

export default function EmptySelectionPlaceholder({ title, description }) {
	const titleHtml = getHtmlString(title);
	const descriptionHtml = getHtmlString(description);

	return (
		<div className="uk-padding hero-explore">
			<div dangerouslySetInnerHTML={{ __html: titleHtml }}></div>
			<div dangerouslySetInnerHTML={{ __html: descriptionHtml }}></div>
		</div>
	);
}
